import constants from "./constants";
import { getUsers, setManagerRole } from "./services";

export function getAllUsers() {
  const begin = () => ({ type: constants.GET_ALL_USERS_BEGIN });
  const success = data => ({
    type: constants.GET_ALL_USERS_SUCCESS,
    payload: data,
  });
  const failure = error => ({
    type: constants.GET_ALL_USERS_FAILURE,
    payload: error,
  });

  return async dispatch => {
    dispatch(begin());
    getUsers()
      .then(data => {
        dispatch(success(data));
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
}

export function setManagerRoleForUser(user, isManager) {
  const begin = () => ({
    type: constants.SET_MANAGER_STATUS_BEGIN,
    payload: user.id,
  });
  const success = data => ({
    type: constants.SET_MANAGER_STATUS_SUCCESS,
    payload: data,
  });
  const failure = error => ({
    type: constants.SET_MANAGER_STATUS_FAILURE,
    payload: error,
  });

  return async dispatch => {
    dispatch(begin());
    setManagerRole(user, isManager)
      .then(data => {
        dispatch(success(data));
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };
}



// WEBPACK FOOTER //
// ./src/modules/manager/actions.js